import { render, staticRenderFns } from "./AuthDiscount.vue?vue&type=template&id=2f230f99&scoped=true"
import script from "./AuthDiscount.vue?vue&type=script&lang=js"
export * from "./AuthDiscount.vue?vue&type=script&lang=js"
import style0 from "./AuthDiscount.vue?vue&type=style&index=0&id=2f230f99&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f230f99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f230f99')) {
      api.createRecord('2f230f99', component.options)
    } else {
      api.reload('2f230f99', component.options)
    }
    module.hot.accept("./AuthDiscount.vue?vue&type=template&id=2f230f99&scoped=true", function () {
      api.rerender('2f230f99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/AuthDiscount.vue"
export default component.exports